import type { IconDefinition } from '@fortawesome/fontawesome-svg-core'
import CustomButton from '@space-lib/components/customButton'
import CustomImage from '@space-lib/components/customImage'
import styled from 'styled-components'

export type ExceptionTypes = {
  title: string
  subtitle: string
  illustration: string
  iconButton?: IconDefinition
  textButton?: string
}

export type ExceptionStateProps = {
  exception: ExceptionTypes
  buttonAction?: () => void
}

const Container = styled.div`
  overflow: hidden;
`

const ExceptionState = ({ exception, buttonAction }: ExceptionStateProps) => {
  return (
    <Container
      data-test='exception-container'
      className='_d-flex _flex-column _align-items-center _justify-content-center _text-center _w-full _h-full'>
      <CustomImage alt='exception-state' src={exception.illustration} className='_mb-5' />

      <h2
        data-test='exception-title'
        className='_text-gray-900 _text-4 _font-weight-light _mb-1 _p-0'>
        {exception.title}
      </h2>

      <p data-test='exception-subtitle' className='_text-gray-600 _text-2 _font-weight _mb-6 _p-0'>
        {exception.subtitle}
      </p>

      {exception.textButton && (
        <CustomButton
          data-test='exception-button'
          className='_p-2 _font-weight-400 _text-2 _mb-8'
          size='lg'
          onClick={buttonAction}
          icon={exception.iconButton}>
          {exception.textButton}
        </CustomButton>
      )}
    </Container>
  )
}

export default ExceptionState
